import { render, staticRenderFns } from "./XiHuOrder.vue?vue&type=template&id=5d65df7b&scoped=true"
import script from "./XiHuOrder.vue?vue&type=script&lang=js"
export * from "./XiHuOrder.vue?vue&type=script&lang=js"
import style0 from "./XiHuOrder.vue?vue&type=style&index=0&id=5d65df7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65df7b",
  null
  
)

export default component.exports